import { Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot
} from '@angular/router';

import { AuthService } from '@igo2/auth';

import { environment, isPartenaireEnv } from '@env';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WithProfilsGuard {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!isPartenaireEnv(environment)) {
      return true;
    }

    const authConfig = environment.auth;
    return this.authService.getProfils().pipe(
      map((profils) => {
        if (
          profils.profils.some(
            (v) => authConfig.profilsGuard?.indexOf(v) !== -1
          )
        ) {
          return true;
        }

        this.authService.redirectUrl = state.url;

        // TODO: add a way to redirect to the a forbidden page and then a button to go to the login page?
        if (authConfig?.loginRoute) {
          this.router.navigateByUrl(authConfig.loginRoute);
        }

        return false;
      })
    );
  }
}
